/**
 * The types of entity limits for collections
 */
export const ENTITY_LIMIT_TYPE = {
	VIEWS_PER_COLLECTION: 'viewsPerCollection',
	COLLECTIONS_PER_SITE: 'collectionsPerSite',
} as const;
